
import Header from './Header';
import Footer from './Footer';
import SideBar from './SideBar';
import React, { Component } from 'react';

class Layout extends Component {

    render() {
        return (
            <main>

                <div id="wrapper">
                    {this.props.topbar ? <Header /> : null}
                    {this.props.sidebar ? <SideBar /> : null}
                    <div className="content-page">
                        <div className="content">
                            <div className="container-fluid">
                                {this.props.children}
                            </div>
                        </div>
                        {this.props.footer ? <Footer /> : null}
                    </div>
                </div>
            </main>
        );
    }
}

export { Layout };

